var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-button',_vm._g(_vm._b({attrs:{"variant":"ghost","m":"0","p":"0","min-w":"auto","h":"auto","w":"auto"}},'c-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }